import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSmsTextTemplateVariables } from 'services/smsConversations';

export const ThunkGetSmsTextTemplateVariables = createAsyncThunk(
  'pod/getSmsTextTemplateVariables',
  async () => {
    const { data } = await getSmsTextTemplateVariables();
    return data;
  },
);
